// @flow

export { formatBoletoNumber } from './format-boleto-number';
export { boletoOutgoingPaymentMapper } from './outgoing-payment-mapper';

const boleto = {
  dueDateFormat: 'dd/MM',
};

export default boleto;
